import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Tag = ({ classes, className, children }) => (
  <div className={classNames(classes.tag, className)} data-element="tag">
    {children}
  </div>
)

Tag.propTypes = {
  classes: PropTypes.shape({
    tag: PropTypes.string,
  }),
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Tag
